<app-header></app-header>
<main class="main-content">
   <!------main-content------>
   <!-----------page_title--------------->
   <section class="page_title  pdt_80  pdb_40 min-height-auto" style="padding-bottom: 0px;">
      <div class="container">
         <div class="row">
            <!---------row----------->

            <!----------row-end---------->
         </div>
      </div>
   </section>
   <!-----------page_title-end-------------->
   <!-----------footer--------------->
   <section class="contact_page pdb_70 pdt_50">
      <div class="container">
         <div class="row">

            <div class="col-lg-6">
               <img src="assets/image/login.png" class="img-fluid">
            </div>
            <!---------row----------->
            <div class="col-lg-6 col-md-12 mx-auto">
               <!---------col----------->
               <div class="contact_us_form">
                  <div class="heading tp_one">

                     <h1> Forgot</h1>
                     <p class="pt-0"> Lorem Ipsum is simply dummy text of the printing and typesetting industry. </p>
                  </div>

                  <div class="form_box type_one remove-pt">
                     <div class="" *ngIf="showRequestOtpForm">
                        <form [formGroup]="requestOtpForm" (ngSubmit)="onSubmit(requestOtpForm.value)" autocomplete="off">
                           <div class="messages"></div>
                           <div class="controls">
                              <div class="row">
                                 <div class="col-lg-12">
                                    <div class="form-group">

                                       <input type="text" class="percent_100 login_input_padding"
                                          formControlName="emailAddress" name="emailAddress" placeholder="Email Address"
                                          [ngClass]="{ 'is-invalid': submitted &amp;&amp; requestOtpForm.controls.emailAddress.errors }"
                                          [style.border-color]="submitted &amp;&amp; requestOtpForm.controls.emailAddress.errors ?'#dc3545' : ''" />

                                       <div *ngIf="submitted &amp;&amp; requestOtpForm.controls.emailAddress.errors"
                                          class="form-text text-danger">
                                          <div *ngIf="requestOtpForm.controls.emailAddress.errors.required">Email is
                                             required</div>
                                          <div *ngIf="requestOtpForm.controls.emailAddress.errors.pattern">Please
                                             enter a valid email</div>
                                          <div *ngIf="requestOtpForm.controls.emailAddress.errors.maxlength">Email
                                             must be under 45 characters</div>
                                       </div>
                                    </div>
                                 </div>

                                 <div class="col-lg-12 text-center">
                                    <div class="form-group ">
                                       <button class="theme_btn tp_two" type="submit">Submit</button><br><br>
                                       <a [routerLink]="['/login']" class="link-back-to-login">Back to Login</a>
                                    </div>
                                 </div>


                              </div>
                           </div>
                        </form>

                     </div>


                  </div>



                  <div class="form_box type_one remove-pt">
                     <div class="" *ngIf="showForgotPasswordForm">
                        <form [formGroup]="forgotPasswordForm"
                           (ngSubmit)="onSubmitForgotPassword(forgotPasswordForm.value)" autocomplete="off">
                           <div class="messages"></div>
                           <div class="controls">
                              <div class="row">
                                 <div class="col-lg-12">
                                    <div class="form-group">

                                       <input type="password" class="percent_100 login_input_padding"
                                          formControlName="newPassword" name="newPassword" placeholder="New Password"
                                          [ngClass]="{ 'is-invalid': submitted &amp;&amp; forgotPasswordForm.controls.newPassword.errors }"
                                          [style.border-color]="submitted &amp;&amp; forgotPasswordForm.controls.newPassword.errors ?'#dc3545' : ''" />

                                       <div *ngIf="submitted &amp;&amp; forgotPasswordForm.controls.newPassword.errors"
                                          class="form-text text-danger">
                                          <div *ngIf="forgotPasswordForm.controls.newPassword.errors.required">Password
                                             is
                                             required</div>
                                          <div *ngIf="forgotPasswordForm.controls.newPassword.errors.pattern">Please
                                             enter a valid
                                             password</div>


                                          <div *ngIf="forgotPasswordForm.controls.newPassword.errors.maxlength">Password
                                             must be under
                                             8 characters</div>

                                       </div>
                                    </div>
                                 </div>

                                 <div class="col-lg-12">
                                    <div class="form-group">

                                       <input type="password" class="percent_100 login_input_padding"
                                          formControlName="confirmPassword" name="confirmPassword"
                                          placeholder="Confirm Password"
                                          [ngClass]="{ 'is-invalid': submitted &amp;&amp; forgotPasswordForm.controls.confirmPassword.errors }"
                                          [style.border-color]="submitted &amp;&amp; forgotPasswordForm.controls.confirmPassword.errors ?'#dc3545' : ''" />

                                       <div
                                          *ngIf="submitted &amp;&amp; forgotPasswordForm.controls.confirmPassword.errors"
                                          class="form-text text-danger">
                                          <div *ngIf="forgotPasswordForm.controls.confirmPassword.errors.required">
                                             Confirm Password is
                                             required</div>

                                          <div *ngIf="forgotPasswordForm.controls.confirmPassword.errors.pattern">Please
                                             enter a valid
                                             password</div>

                                          <div *ngIf="forgotPasswordForm.controls.confirmPassword.errors.maxlength">
                                             Password must be under
                                             8 characters</div>

                                          <div *ngIf="forgotPasswordForm.controls.confirmPassword.errors.mustMatch">
                                             Passwords do not match</div>

                                       </div>
                                    </div>
                                 </div>

                                 <div class="col-lg-12">
                                    <div class="form-group">

                                       <input type="password" class="percent_100 login_input_padding"
                                          formControlName="requestOtp" name="requestOtp" placeholder="Enter OTP"
                                          [ngClass]="{ 'is-invalid': submitted &amp;&amp; forgotPasswordForm.controls.requestOtp.errors }"
                                          [style.border-color]="submitted &amp;&amp; forgotPasswordForm.controls.requestOtp.errors ?'#dc3545' : ''" />

                                       <div *ngIf="submitted &amp;&amp; forgotPasswordForm.controls.requestOtp.errors"
                                          class="form-text text-danger">
                                          <div *ngIf="forgotPasswordForm.controls.requestOtp.errors.required">OTP is
                                             required</div>

                                       </div>
                                    </div>
                                 </div>

                                 <div class="col-lg-12 text-center">
                                    <div class="form-group ">
                                       <button class="submit_btn " type="submit">Submit</button><br>
                                    </div>
                                 </div>


                              </div>
                           </div>
                        </form>

                     </div>


                  </div>


               </div>
               <!---------col-end---------->
            </div>
         </div>
      </div>

   </section>
   <app-footer></app-footer>

</main>
<app-scrolltotop></app-scrolltotop>